import { atom } from "jotai";
import { type AccountEntity } from "@/api/__generated__/orval/accounts";

export const accountsAtom = atom<AccountEntity[] | []>([]);
